import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { ContentPlanRootState as S } from '../../elements/contentPlan/store';
import { ElementAction } from '../../elements/elementAction';
import { Functions } from '../../types/types';
import { WorkspaceSettingProps } from '../../types';
import { updateWorkspaceSetting } from '../ContentPlanning/contentPlanningReducer';

type P = Partial<WorkspaceSettingProps>;

const save =
  (setting: P): ElementAction<Functions, S> =>
  async (dispatch, getState, { getAPI }) => {
    const workspaceRefId = getState().planning?.selectedWorkspace?.props?.refId;
    if (workspaceRefId) {
      const { upsertWorkspaceSettings } = getAPI();
      const newSetting = await upsertWorkspaceSettings(workspaceRefId, setting);
      dispatch(updateWorkspaceSetting(workspaceRefId, newSetting));
    }
  };

export const useActions = () => {
  const dispatch: Dispatch<any> = useDispatch();
  return {
    save: (s: P) => dispatch(save(s))
  };
};
